import type { TaskType } from '../index'

const STORE_KEY = '__AL_EX_prefetchApi_result_qXdTr8HCwJUQXCGJ'

// 建立关键任务锁，由 hydrate 拦截阻塞，确保 global 的关键任务完成
if (process.browser) {
  ;(window as any).__AL_EX_lockCriticalPrefetchApiTask_AIi82DiKUcAQHEa2 = async () => {
    const store = getTasksStore()
    const begin = Date.now()

    // 注意，ssr 时，store 里为空

    // 等待 loading 中的关键任务
    const criticalLoadingList: Array<Promise<TaskType>> = []
    Object.keys(store).forEach((propKey) => {
      const task = store[propKey]
      if (task.config.critical) {
        if (task.status === 'LOADING') {
          criticalLoadingList.push(
            new Promise((resolve, reject) => {
              ;(task.request as any).then(() => {
                if (task.status !== 'COMPLETE') {
                  console.error(task)
                  reject(
                    new Error(
                      `[prefetchApi] 关键任务在最终阻塞等待阶段，loading 后仍未完成 ${task.propKey}`
                    )
                  )
                }
                resolve()
              })
            })
          )
        } else if (task.status !== 'COMPLETE') {
          console.error(task)
          throw new Error(
            `[prefetchApi] 关键任务在最终阻塞等待阶段，仍未正确启动 ${task.propKey}`
          )
        }
      }
    })
    // 等待任务完成
    await Promise.all(criticalLoadingList) // 异常将抛出

    const diff = Date.now() - begin
    if (diff > 35) {
      console.warn(
        `业务前置任务(阻塞hydrate的关键路径)，已完成。阻塞 ${diff}ms`
      )
    }
  }
}

function getTasksStore() {
  return (window as any)[STORE_KEY] as { [propKey: string]: TaskType }
}
